// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7nc4h","toggleWrap":"styles_toggleWrap__Mk7L4","content":"styles_content__gR5in","selectAreaCode":"styles_selectAreaCode__zx_wu"};